<template>
    <div class="page fill-height">
        <v-container class="d-flex flex-column align-center justify-lg-center pb-lg-16 fill-height px-lg-7 px-6">

            <v-card class="bordered pa-0 mt-15 rounded mt-lg-0" :class="{'w-100': phoneOnly}">
                <div class="form-wrapper">
                    <div class="d-flex justify-center py-3">
                        <logo height="75" />
                    </div>

                    <v-card-text>
                        <form @submit.prevent="login">
                            <v-text-field label="Email" name="email" v-model="email" :disabled="loading" hide-details></v-text-field>
                            <v-text-field label="Password" name="password" hide-details v-model="password" :disabled="loading" class="my-5" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword"></v-text-field>
                            <div class="d-flex justify-space-between align-center mb-4">
                                <div v-if="pcOnly">
                                    <v-checkbox v-model="remember" :disabled="loading" label="Remember" class="ma-0" :class="{'details-text': phoneOnly}" hide-details></v-checkbox>
                                </div>
                                <div>
                                    <v-btn text dense to="/reset-password" :disabled="loading" class="forget-password muted--text text-capitalize px-0" :class="{'details-text': phoneOnly}">Reset Password</v-btn>
                                </div>
                            </div>
                            <v-btn type="submit" block depressed large :disabled="loading" color="primary" @click.prevent="login">Login</v-btn>

                            <div class="mt-2 details-text text-center">
                                <v-btn x-small text color="muted" :to="{name: 'terms'}">Terms And Conditions</v-btn>
                            </div>
                        </form>
                        <div class="text-center medium-text mt-6">
                            <v-divider class="mb-2 mt-2"></v-divider>
                            
                            <div class="mb-2 details-text muted--text">Don't have an account ?</div>
                            <v-btn dense small outlined block :to="{name: 'register'}" :disabled="loading" class="primary--text px-1">Register</v-btn>
                        </div>
                    </v-card-text>
                </div>
            </v-card>
        </v-container>

        <slot name="footer" />
    </div>
</template>

<script>

// @ is an alias to /src
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import AppAPI from '@/app-api'

export default {
    name: 'login',
    data(){
        return {
            email: '',
            password: '',
            remember: true,
            loading: false,
            showPassword: false,
        };
    },
    components: {
        
    },
    computed:{
        ...GlobalComputed 
    },
    methods: {
        ...GlobalMethods,
        login(){
            const self = this;

            let email = this.email,
                password = this.password,
                remember = this.remember;

            if (this.capRunning && this.isProduction){
                AppAPI.Notifications.getDeviceToken(response=>{
                    const deviceToken = response.token;
                    window.console.log('EBM: Device token (' + deviceToken + ')');
                    self.loginAction(email, password, remember, deviceToken);
                }, error=>{
                    console.error('EBM: ' + JSON.stringify(error));
                    // window.alert(JSON.stringify(error));
                    self.loginAction(email, password, remember);
                })
            }else{
                self.loginAction(email, password, remember);
            }
        },
        loginAction(email, password, remember = true, deviceToken=null){
             
            if (email && password){
                this.loading = true;
                this.closeMsg();
                let data = { email, password, remember };
                if (deviceToken){
                    data.deviceToken = deviceToken;
                }

                this.$store.dispatch('loginAction', data).then(()=>{
                    this.loading = false;
                    this.closeMsg();
                    this.$router.push({name: 'home'});
                }).catch(error=>{
                    this.loading = false;
                    if (error.response && error.response.data.message === 'SUSPENDED_ACCOUNT'){
                        this.showLoginMsg('Your account has been blocked, contact support.');
                    }else if (error.response && (error.response.status === 401)){
                        this.showLoginMsg('Email or Password is incorrect');
                    }else if (error.response && error.response.data.message === 'NOT_ACTIVATED_ACCOUNT'){
                        this.showLoginMsg('Your account is under review, we will try to activate it ASAP.');
                    }else if (error.response && error.response.status === 422){
                        this.showLoginMsg('Data you entered is not valid');
                    }else{
                        this.showLoginMsg('Error occurred during signing you in');
                    }
                })
            }else{
                this.showLoginMsg("Inputs are required")
            }
        },
        showLoginMsg(msg){
            this.showMsg(msg, 'error');
        },
        closeMsg(){
            if (this.$store.state.globalModule.snackMsg.text){
                this.$store.dispatch('addSnackMsg', { show: false, text: ''});
            }
        },
        checkAppAutoLogin(){
            if (!this.capRunning && this.$vuetify.breakpoint.mdAndDown){
                const saved_token = window.localStorage.getItem('tK');
                if (!saved_token){
                    let tk = this.$route.query.tk;
                    if (tk && this.$route.query.from === 'app' && this.$route.query.to === 'w'){
                        tk = tk.split('').reverse().join('');
                        // this.$router.push({query: {}});
                        window.localStorage.setItem('tK', tk);
                        // this.$router.push({name: 'wallet'});
                        let redirectTo = '/wallet';
                        if (this.$route.query.q){
                            redirectTo += '?';
                            redirectTo += this.$route.query.q.replaceAll(':', '=').replaceAll('|', '&');
                        }
                        window.location = redirectTo;
                    }
                }
            }
        },
    },
    watch: {
        email(){
            this.closeMsg();
        },
        password(){
            this.closeMsg();
        }
    },
    created(){
        this.checkAppAutoLogin();
    },
    mounted(){
        

    }
}
</script>

<style lang="scss" scoped>
.page{
    background-image: url(/img/_background.png);
    background-size: cover;
    background-position: top center;
}
</style>